import { IEnvironment } from 'config/env';

import devTF from './dev-tf';

// The eu-central-1 standby serves the dev shape on its own hostnames. Every
// host that has a Frankfurt copy moves to it, so the standby works while
// eu-west-1 is down.
const environment: IEnvironment = {
  ...devTF,
  GQL_URL: 'https://api-dr.dev.ef.studio/gipfeli/',
  MEDIA_URL: 'https://teach-assets-dr.dev.ef.studio',
  TF_SVCGATEWAY_URL: 'https://api-dr.dev.ef.studio/teacher-first',
  CATALYST_PLAYER_URL: 'https://lesson-player-dr.dev.ef.studio/?product=gap-b2b',
  CONTENT_PREVIEW_URL: 'https://content-preview-dr.dev.ef.studio/',
  EVC_TUNNELS: {
    ...devTF.EVC_TUNNELS,
    US_NV: 'https://dev-dr.evc.ef.com',
  },
  DATADOG: devTF.DATADOG && {
    ...devTF.DATADOG,
    VIRTUAL_ENV: 'dr-dev',
  },
};

export default environment;
